import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ScreenFrame, ListCard, EmptyState, ViewToggle } from '../PrototypeShared';
import { Build } from '@mui/icons-material';

const MOCK_RECIPES = [
  { id: 'PR-1', name: 'Demo Product A', lot: '12504' },
  { id: 'PR-2', name: 'Demo Product B', lot: '12903' },
];

export default function ProductionRecipesScreen() {
  const [view, setView] = useState('list');

  return (
    <ScreenFrame
      title="Production recipes"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
          <Button component={Link} to="/prototype/production-recipes/new" startIcon={<Add />} variant="contained" size="small">New recipe</Button>
        </>
      }
    >
      {view === 'empty' && (
        <EmptyState icon={Build} title="No recipes" description="Create a production recipe." actionLabel="New recipe" onAction={() => window.location.assign('/prototype/production-recipes/new')} />
      )}
      {view === 'list' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {MOCK_RECIPES.map((r) => (
            <ListCard key={r.id} title={r.name} subtitle={`Lot ${r.lot}`} to={`/prototype/production-recipes/${r.id}`} />
          ))}
        </Box>
      )}
    </ScreenFrame>
  );
}
